import { render, staticRenderFns } from "./ImportPointeApplication.vue?vue&type=template&id=1e85217f&scoped=true"
import script from "./ImportPointeApplication.vue?vue&type=script&lang=js"
export * from "./ImportPointeApplication.vue?vue&type=script&lang=js"
import style0 from "./ImportPointeApplication.vue?vue&type=style&index=0&id=1e85217f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e85217f",
  null
  
)

export default component.exports